<div *ngIf="busy">Fetching data...</div>

<div *ngIf="!busy" class="tournament-bracket">
  <h1>{{wins}} wins - {{losses}} losses</h1>
  (touch Opponent or Date to sort the table)
  <table class="table table-bordered">
    <thead>
      <th>
        <a href="#" (click)="changeSort($event, 'lastName', -sortData.order)">Opponent</a>
        &nbsp;
        <fa-icon *ngIf="sortData.field == 'lastName' && sortData.order == 1" [icon]="faCaretDown" (click)="changeSort($event,'lastName',-1)">
        </fa-icon>
        <fa-icon *ngIf="sortData.field == 'lastName' && sortData.order == -1" [icon]="faCaretUp" (click)="changeSort($event, 'lastName',1)">
        </fa-icon>
      </th>
      <th>Score</th>
      <th>
        <a href="#" (click)="changeSort($event, 'createdAt', -sortData.order)">Date</a>
        &nbsp;
        <fa-icon *ngIf="sortData.field == 'createdAt' && sortData.order == 1" [icon]="faCaretDown" (click)="changeSort($event,'createdAt',-1)">
        </fa-icon>
        <fa-icon *ngIf="sortData.field == 'createdAt' && sortData.order == -1" [icon]="faCaretUp" (click)="changeSort($event, 'createdAt',1)">
        </fa-icon>
      </th>
    </thead>
    <tbody>
      <tr *ngFor="let s of scores">
        <td>
          {{s.opponentFullName}}
        </td>
        <td [ngClass]="{'win':s.points==3 || s.points==4, 'loss':s.points<3}">{{s.score}}</td>
        <td>
          {{s.getDate()}}
          <ng-container *ngIf="isTournament(s.ladderId)">
          <br ><span style="font-size: 80%">Tournament</span>
          </ng-container>
        </td>
      </tr>
    </tbody>

  </table>
</div>